import React from 'react';
import { Card, Typography, Row, Col, Tag, List, Avatar, Input, Select } from 'antd';
import { BookOutlined, CompassOutlined, StarOutlined, SearchOutlined } from '@ant-design/icons';
import './Majors.less';

const { Title, Paragraph, Text } = Typography;
const { Search } = Input;
const { Option } = Select;

interface Major {
  id: number;
  name: string;
  code: string;
  category: string;
  level: string;
  department: string;
  description: string;
  duration: string;
  degree: string;
  keywords: string[];
  featured?: boolean;
}

const Majors: React.FC = () => {
  // 模拟专业数据
  const majors: Major[] = [
    {
      id: 1,
      name: '通信工程',
      code: '080703',
      category: '工学',
      level: '国家级一流本科专业',
      department: '信息与通信工程学院',
      description: '本专业培养具有通信技术、通信系统和通信网络等方面的知识，能在通信领域中从事研究、设计、制造、运营及在国民经济各部门和国防工业中从事开发、应用通信技术与设备的高级工程技术人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['通信网络', '信号处理', '移动通信', '光纤通信'],
      featured: true
    },
    {
      id: 2,
      name: '电子信息工程',
      code: '080701',
      category: '工学',
      level: '国家级一流本科专业',
      department: '电子工程学院',
      description: '本专业培养具备电子技术和信息系统的基础知识和应用能力，能从事各类电子设备和信息系统的研究、设计、制造、应用和开发的高级工程技术人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['电子技术', '信息系统', '嵌入式系统', '传感器技术']
    },
    {
      id: 3,
      name: '计算机科学与技术',
      code: '080901',
      category: '工学',
      level: '国家级一流本科专业',
      department: '计算机学院',
      description: '本专业培养具有良好的科学素养，系统地、较好地掌握计算机科学与技术包括计算机硬件、软件与应用的基本理论、基本知识和基本技能与方法，能在科研部门、教育单位、企业、事业、技术和行政管理部门等单位从事计算机教学、科学研究和应用的计算机科学与技术学科的高级科学技术人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['计算机科学', '人工智能', '软件工程', '数据结构']
    },
    {
      id: 4,
      name: '人工智能',
      code: '080717TK',
      category: '工学',
      level: '新兴交叉专业',
      department: '人工智能学院',
      description: '本专业培养具有扎实的计算机科学基础，系统掌握人工智能理论与技术，能够在人工智能领域从事科研、教学和应用开发的复合型高级专门人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['机器学习', '深度学习', '计算机视觉', '自然语言处理'],
      featured: true
    },
    {
      id: 5,
      name: '网络空间安全',
      code: '080911TK',
      category: '工学',
      level: '国家级一流本科专业',
      department: '网络空间安全学院',
      description: '本专业培养具有扎实的网络安全理论基础，系统掌握网络安全技术与方法，能够在网络空间安全领域从事科学研究、技术开发和管理工作的高级专门人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['网络安全', '信息安全', '密码学', '安全协议']
    },
    {
      id: 6,
      name: '自动化',
      code: '080801',
      category: '工学',
      level: '省级一流本科专业',
      department: '自动化学院',
      description: '本专业培养具有坚实的自然科学基础，良好的计算机、外语、经济、管理等方面的应用基础；具有控制科学与工程学科的基本理论和基本知识，能在运动控制、工业过程控制、电力电子技术、检测与自动化仪表、电子与计算机技术、信息处理等领域从事系统分析、系统设计、系统运行、科技开发及研究等方面工作的高级工程技术人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['自动控制', '智能系统', '机器人技术', '过程控制']
    },
    {
      id: 7,
      name: '软件工程',
      code: '080902',
      category: '工学',
      level: '国家级一流本科专业',
      department: '计算机学院',
      description: '本专业培养具有扎实的计算机科学基础理论，掌握软件工程领域的前沿技术和软件开发方法，具备软件系统分析、设计、开发、测试和管理能力，能在计算机软件领域从事科学研究、技术开发和管理工作的高级专门人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['软件开发', '软件测试', '软件工程', '系统架构']
    },
    {
      id: 8,
      name: '数字媒体技术',
      code: '080906',
      category: '工学',
      level: '省级一流本科专业',
      department: '数字媒体与设计艺术学院',
      description: '本专业培养具有良好的数字媒体技术和艺术基础，能够进行数字媒体作品的设计和制作的高级技术人才。毕业生可以在广播、电视、电影、网络媒体、广告公司等领域从事数字媒体内容设计、开发和制作工作。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['数字媒体', '计算机图形学', '动画设计', '交互设计']
    },
    {
      id: 9,
      name: '光电信息科学与工程',
      code: '080705',
      category: '工学',
      level: '国家级一流本科专业',
      department: '光电信息学院',
      description: '本专业培养具有光电信息科学与工程方面的知识，能在光电信息科学与工程、光电子技术、光电仪器及相关的电子信息科学、计算机科学等领域从事科学研究、教学、产品设计、生产技术或管理工作的高级专门人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['光学工程', '激光技术', '光电检测', '光纤通信']
    },
    {
      id: 10,
      name: '数据科学与大数据技术',
      code: '080910T',
      category: '工学',
      level: '新兴交叉专业',
      department: '计算机学院',
      description: '本专业培养具有扎实的数据科学基础理论，系统掌握大数据处理与分析技术，能够在大数据领域从事科学研究、技术开发和管理工作的高级复合型人才。',
      duration: '四年',
      degree: '工学学士',
      keywords: ['大数据', '数据挖掘', '机器学习', '云计算'],
      featured: true
    }
  ];

  // 学院列表
  const departments = [
    '信息与通信工程学院',
    '电子工程学院',
    '计算机学院',
    '自动化学院',
    '人工智能学院',
    '数字媒体与设计艺术学院',
    '网络空间安全学院',
    '光电信息学院'
  ];

  // 获取特色专业
  const featuredMajors = majors.filter(major => major.featured);

  return (
    <div className="majors-container">
      <Title level={2}>专业设置</Title>
      
      {/* 专业概况 */}
      <Card className="overview-card">
        <Title level={4}>专业概况</Title>
        <Paragraph>
          羊小羊设有32个本科专业，涵盖工学、理学、管理学等多个学科门类。其中，国家级一流本科专业建设点15个，
          省级一流本科专业建设点12个。学校坚持"厚基础、宽口径、强能力、重创新"的人才培养理念，
          不断优化专业结构，深化教育教学改革，提高人才培养质量。
        </Paragraph>
        
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6}>
            <div className="stat-box">
              <Statistic
                title="本科专业总数"
                value={32}
                prefix={<BookOutlined />}
                valueStyle={{ color: '#3f8600' }}
              />
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="stat-box">
              <Statistic
                title="国家级一流专业"
                value={15}
                prefix={<StarOutlined />}
                valueStyle={{ color: '#cf1322' }}
              />
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="stat-box">
              <Statistic
                title="省级一流专业"
                value={12}
                prefix={<BookOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="stat-box">
              <Statistic
                title="新兴交叉专业"
                value={5}
                prefix={<CompassOutlined />}
                valueStyle={{ color: '#fa8c16' }}
              />
            </div>
          </Col>
        </Row>
      </Card>

      {/* 搜索和筛选 */}
      <div className="search-filter-section">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <Search
              placeholder="搜索专业名称或代码"
              prefix={<SearchOutlined />}
              allowClear
              enterButton
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Select
              placeholder="按学院筛选"
              style={{ width: '100%' }}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {departments.map((dept, index) => (
                <Option key={index} value={dept}>{dept}</Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Select
              placeholder="按学科门类筛选"
              style={{ width: '100%' }}
              allowClear
            >
              <Option value="工学">工学</Option>
              <Option value="理学">理学</Option>
              <Option value="管理学">管理学</Option>
              <Option value="经济学">经济学</Option>
              <Option value="文学">文学</Option>
            </Select>
          </Col>
        </Row>
      </div>

      {/* 特色专业展示 */}
      <div className="featured-majors-section">
        <Title level={3} className="section-title">
          <StarOutlined /> 特色专业
        </Title>
        <Row gutter={[16, 16]}>
          {featuredMajors.map(major => (
            <Col xs={24} md={8} key={major.id}>
              <Card
                className="featured-major-card"
                hoverable
                extra={<Tag color="gold">特色专业</Tag>}
              >
                <div className="major-header">
                  <BookOutlined style={{ fontSize: 24, color: '#1890ff', marginRight: 8 }} />
                  <Title level={4} style={{ margin: 0 }}>{major.name}</Title>
                </div>
                <Text type="secondary">专业代码: {major.code}</Text>
                <Paragraph ellipsis={{ rows: 3 }} className="major-description">
                  {major.description}
                </Paragraph>
                <div className="major-meta">
                  <Tag color="blue">{major.category}</Tag>
                  <Tag color="green">{major.duration}</Tag>
                  <Tag color="purple">{major.degree}</Tag>
                </div>
                <Text type="secondary" className="view-details">查看详情 &gt;</Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* 专业列表 */}
      <div className="all-majors-section">
        <Title level={3} className="section-title">
          <BookOutlined /> 专业列表
        </Title>
        <Card>
          <List
            itemLayout="vertical"
            size="large"
            dataSource={majors}
            renderItem={(major) => (
              <List.Item
                key={major.id}
                className="major-list-item"
                extra={
                  <div className="major-extra">
                    <Tag color={major.level.includes('国家级') ? 'red' : 'blue'}>{major.level}</Tag>
                    <br />
                    <Text type="secondary">{major.department}</Text>
                  </div>
                }
              >
                <List.Item.Meta
                  avatar={<Avatar icon={<BookOutlined />} />}
                  title={
                    <div>
                      <Text strong style={{ fontSize: 18, marginRight: 12 }}>{major.name}</Text>
                      <Tag color="blue">{major.category}</Tag>
                    </div>
                  }
                  description={
                    <div>
                      <Text type="secondary" style={{ marginRight: 16 }}>专业代码: {major.code}</Text>
                      <Text type="secondary" style={{ marginRight: 16 }}>修业年限: {major.duration}</Text>
                      <Text type="secondary">授予学位: {major.degree}</Text>
                    </div>
                  }
                />
                <Paragraph ellipsis={{ rows: 2 }}>{major.description}</Paragraph>
                <div className="major-keywords">
                  {major.keywords.map((keyword, index) => (
                    <Tag key={index} color="default" className="keyword-tag">{keyword}</Tag>
                  ))}
                </div>
              </List.Item>
            )}
          />
        </Card>
      </div>
    </div>
  );
};

// 导入Statistic组件
import { Statistic } from 'antd';

export default Majors;